import React from "react";
import "./designs.css";
import { Link } from "react-router-dom";

const Design1 = () => {
  return (
    <div className="design-one-box">
      <div className="design-one-content">
        <p className="design-one-heading">
          Explore Your Favorite Movies with MoviesApp
        </p>
        <p className="design-one-para">
          MoviesApp is a comprehensive platform that offers detailed information
          about your favorite movies, including ratings, reviews, and more. With
          MoviesApp, you can easily find the latest releases, upcoming movies,
          and popular classics, and stay up-to-date with the latest news and
          trends in the film industry.
        </p>
        <Link className="design-one-link" to="/search">
          <button className="design-one-btn">Explore &nbsp;&rarr;</button>
        </Link>
      </div>
    </div>
  );
};

export default Design1;
